import React, { forwardRef, memo } from "react";

const Index = forwardRef(({ as, children, ...rest }, ref) => {
  const Component = as || "p";
  return <Component {...rest}>{children}</Component>;
});

export default memo(Index);
